import { useEffect } from 'preact/hooks';
import { success, error } from '../store/state';
import { Icon } from './Icon';

export function ToastStack() {
  useEffect(() => {
    if (!success.value) return;
    const t = setTimeout(() => {
      success.value = null;
    }, 3200);
    return () => clearTimeout(t);
  }, [success.value]);

  useEffect(() => {
    if (!error.value) return;
    const t = setTimeout(() => {
      error.value = null;
    }, 5000);
    return () => clearTimeout(t);
  }, [error.value]);

  if (!success.value && !error.value) return null;

  return (
    <div class="toast-stack">
      {success.value && (
        <div class="toast success">
          <Icon name="circle-check" size={16} style={{ color: 'var(--success)' }} />
          <span>{success.value}</span>
          <button class="toast-close" onClick={() => (success.value = null)} aria-label="Cerrar">
            <Icon name="x" size={14} />
          </button>
        </div>
      )}
      {error.value && (
        <div class="toast error">
          <Icon name="circle-alert" size={16} style={{ color: 'var(--danger)' }} />
          <span>{error.value}</span>
          <button class="toast-close" onClick={() => (error.value = null)} aria-label="Cerrar">
            <Icon name="x" size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
